// @ts-ignore
import { apiGetV2 } from '../utils/api'
import { IShop } from '../models/contracts/shop'

export const getShopListAPI = async ({
  companyId,
  isActive = true,
}: {
  companyId: string
  isActive?: boolean
}): Promise<IShop[]> => {
  const response = await apiGetV2(`internal/companies/${companyId}/shops?isActive=${isActive}`)
  return response?.data || []
}



// WEBPACK FOOTER //
// ./src/api/shopV2.ts